import type { ReactNode } from 'react';
import { useOverlayDismiss } from './useOverlayDismiss';

type Props = {
  children: ReactNode;
  onClose?: () => void;
  className?: string;
};

export default function ModalOverlay({
  children,
  onClose,
  className = 'modal-overlay',
}: Props) {
  const dismiss = useOverlayDismiss(onClose);
  return (
    <div className={className} {...dismiss}>
      {children}
    </div>
  );
}
